module.exports = __webpack_public_path__ + "img/journey3.24db5e39.png";